module.exports = __webpack_public_path__ + "static/media/mail-icon.cb3d2593.svg";